import { sendAmplitudeData, setAmplitudeUserId } from './amplitude';
import { sendFirebaseEvent, setUserId } from './firebase';
import { sendLockerStudioData } from './lockerStudio';
import { BI_EVENTS } from './biEvents';

const isStage = process.env.REACT_APP_ENV === 'stage';

export const sendAnalyticsEvents = (eventName, eventParams = {}) => {
  const biEventName = BI_EVENTS[eventName] ?? eventName;

  sendAmplitudeData(eventName, eventParams);
  sendFirebaseEvent(eventName, eventParams);
  sendLockerStudioData(biEventName, eventParams);
};

export const setAnalyticsUserId = (userId = '') => {
  setAmplitudeUserId(userId);
  setUserId(userId);
};

export const pushFBEvent = (data, eventId) => {
  if (window.fbq) {
    window.fbq('track', `Purchase${isStage ? '_test' : ''}`, data, {
      eventID: eventId,
    });
  }
};
